import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import OpenLetterSign from './OpenLetterSign';
import OpenLetterReport from './OpenLetterReport';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/openletter-report">
          <OpenLetterReport />
        </Route>
        <Route path="/openletter/:uuid">
          <OpenLetterSign />
        </Route>
        <Route path="/">
          <App />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
